import { createFileRoute, redirect } from "@tanstack/react-router";
import { PermissionsClient } from "@/features/permissions/PermissionsClient";
import { fetchSession, sessionQueryKey } from "@/lib/auth";
import { isAdmin } from "@/lib/access";

// Beheer › Rechten — beheer itself: whoever may hand out rights is not something a
// right can grant. A UX gate; the API enforces requireRole("admin") regardless
// (services/api/src/modules/users/rolePermissions.router.ts).
export const Route = createFileRoute("/_shell/permissions")({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData({ queryKey: sessionQueryKey, queryFn: fetchSession });
    if (!isAdmin(session)) throw redirect({ to: "/dashboard" });
  },
  component: PermissionsClient,
});
